import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck, Lock, CreditCard, DownloadIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="final-cta" className="bg-brand-text py-10 sm:py-14 px-4" data-id="element-47">
      <div className="max-w-content mx-auto text-center" data-id="element-48">
        <FadeIn data-id="element-49">
          <div className="relative w-full max-w-[280px] mx-auto mb-4 aspect-[3/4] sm:aspect-square" data-id="element-50">
            <img src="https://cdn.magicpatterns.com/uploads/f7LEfb6CDQ2FyjEpK2R533/portada.png" alt="Closet Flaco Express eBook" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-51" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-52">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-bg mb-2" data-id="element-53">
            Hoy puedes verte diferente. Sin esperar.
          </h2>
          <p className="text-brand-accent text-lg sm:text-xl font-medium mb-4" data-id="element-54">
            Closet Flaco Express — Acceso Inmediato
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-55">
          <div className="bg-white/5 border border-white/10 rounded-2xl p-4 mb-4 inline-block min-w-[280px]" data-id="element-56">
            <p className="text-black text-lg mb-1" data-id="element-57">
              Valor real:{' '}
              <span className="line-through decoration-red-500 decoration-2" data-id="element-58">
                $25
              </span>
            </p>
          </div>

          <div className="mb-4" data-id="element-59">
            <a href="https://www.tumundoequilibrado.com/cart/51367199506727:1" target="_blank" rel="noopener noreferrer" data-id="element-60">
              <motion.button className="relative inline-flex items-center gap-3 text-[#1A1A1A] font-bold py-5 px-10 rounded-full shadow-xl text-xl sm:text-2xl cursor-pointer overflow-hidden tracking-wide" style={{
              backgroundColor: '#FFD600'
            }} whileHover={{
              scale: 1.07
            }} whileTap={{
              scale: 0.95
            }} animate={{
              boxShadow: ['0 0 0 0 rgba(255, 214, 0, 0.5)', '0 0 0 16px rgba(255, 214, 0, 0)', '0 0 0 0 rgba(255, 214, 0, 0)'],
              y: [0, -4, 0],
              scale: [1, 1.03, 1]
            }} transition={{
              boxShadow: {
                duration: 1.8,
                repeat: Infinity,
                ease: 'easeInOut'
              },
              y: {
                duration: 1.8,
                repeat: Infinity,
                ease: 'easeInOut'
              },
              scale: {
                duration: 1.8,
                repeat: Infinity,
                ease: 'easeInOut'
              }
            }} data-id="element-61">
                <DownloadIcon className="w-7 h-7" strokeWidth={2.5} data-id="element-62" />
                <span data-id="element-63">¡Descarga ya por solo!</span>
                <span className="bg-[#1A1A1A] text-[#FFD600] rounded-full py-1 px-4 text-lg font-extrabold shadow-inner" data-id="element-64">
                  $8,99
                </span>
              </motion.button>
            </a>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-65">
          <Button fullWidth className="mb-2 py-5 text-xl" data-id="element-66">
            🚀 ¡SÍ! QUIERO VERME ESTILIZADA AHORA
          </Button>

          <p className="text-brand-bg/80 text-sm mb-3" data-id="element-67">
            Pago único. Sin suscripción.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-5 text-sm text-brand-bg/80 mb-4" data-id="element-68">
            <span className="flex items-center gap-1.5" data-id="element-69">
              <Lock className="w-4 h-4" data-id="element-70" /> Pago 100% seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-71">
              <ShieldCheck className="w-4 h-4" data-id="element-72" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-73">
              <CreditCard className="w-4 h-4" data-id="element-74" /> Descarga instantánea
            </span>
          </div>

          <div className="flex justify-center items-center gap-3 opacity-50 grayscale" data-id="element-75">
            <div className="h-6 w-10 bg-white/20 rounded flex items-center justify-center text-[10px] font-bold text-white" data-id="element-76">
              VISA
            </div>
            <div className="h-6 w-10 bg-white/20 rounded flex items-center justify-center text-[10px] font-bold text-white" data-id="element-77">
              MC
            </div>
            <div className="h-6 w-10 bg-white/20 rounded flex items-center justify-center text-[10px] font-bold text-white" data-id="element-78">
              AMEX
            </div>
            <div className="h-6 w-10 bg-white/20 rounded flex items-center justify-center text-[10px] font-bold text-white" data-id="element-79">
              PPAL
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}